module.exports = __webpack_public_path__ + "img/applemusic.e2a7dfc0.png";